import { FormArray, FormGroup } from '@angular/forms';

// Mutually-exclusive deviation rights (16 = Administrate all, 17 = View all,
// 19 = View all in same department). Only one may be active at a time.
const DEVIATION_EXCLUSIVE_RIGHTS = ['16', '17', '19'];

/**
 * Disables the other deviation rights when one is checked. Shared by the
 * user-edit and business-user-edit forms for both load and change. #5750
 * @param allowEnable re-enable non-selected members (change only; load keeps
 *   the account-level disabled state).
 */
export function applyDeviationRightsExclusivity(
  form: FormGroup,
  categoryKey: string,
  allowEnable = false
): void {
  const arr = form.controls[categoryKey] as FormArray;
  if (!arr || !arr.controls) {
    return;
  }

  const byId = new Map<string, FormGroup>();
  for (const ctrl of arr.controls as FormGroup[]) {
    const id = Object.keys(ctrl.controls)[0];
    if (DEVIATION_EXCLUSIVE_RIGHTS.includes(id)) {
      byId.set(id, ctrl);
    }
  }

  const checkedId = DEVIATION_EXCLUSIVE_RIGHTS.find(
    (id) => !!byId.get(id)?.getRawValue()[id]
  );

  for (const id of DEVIATION_EXCLUSIVE_RIGHTS) {
    const ctrl = byId.get(id);
    if (!ctrl) {
      continue;
    }
    if (checkedId && id !== checkedId) {
      ctrl.disable();
    } else if (allowEnable) {
      ctrl.enable();
    }
  }
}
